import FlashLib from "flashlib";
import LocalizationManager from "Engine/base/localization/LocalizationManager";
import EntryPoint from "Engine/EntryPoint";
//444013
export default class BasePaytableInfoContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
    }

    init() {
        this.versionText = this.getChildByName('versionText');
        this.versionText.text = LocalizationManager.getLocalizedText('payout_version', [EntryPoint.configRelaxData.gameVersion]);
    }

    addListeners() {

    }
}